import { AnimatedSwitch } from '@inwink/animatedswitch';
import { Route } from 'react-router-dom';
import * as React from 'react';
import { i18NHelperContext } from '@@services/i18nservice';
import { PageTransition } from "./transitions";
import type { IAppShellProps } from './appshell';
import { OpenContentPage } from '../routes/opencontent/opencontent';
import { loadablePageFor } from '@@modules/appmodules';
import { NotFoundPage } from '@@modules/common/notfound/notfound';
import { LicenseExpiredPage } from '@@modules/common/licenseexpired/licenseexpired';

export interface IAppShellRoutesProps extends IAppShellProps {
    visualstate: string[];
}

export class AppShellRoutes extends React.Component<IAppShellRoutesProps, any> {
    RootShell: any;

    MyEventsShell: any;

    EventShell: any;

    CommunityShell: any;

    CustomerShell: any;

    DevsPortalShell: any;

    constructor(props) {
        super(props);
        this.MyEventsShell = loadablePageFor(
            () => import(/* webpackChunkName: "shellmyevents" */ '../routes/myevents/myeventsshell')
                .then((mod) => mod.MyEventsShell),
            { noInheritanceAfterFirstLoad: true }, null, null, "nobackground myeventshell"
        );

        this.RootShell = loadablePageFor(
            () => import(/* webpackChunkName: "shelladmin" */ '@@modules/admin/admin')
                .then((mod) => mod.RootAppShell),
            { noInheritanceAfterFirstLoad: true }, null, null, "nobackground rootshell"
        );

        this.EventShell = loadablePageFor(
            () => import(/* webpackChunkName: "shellevent" */ '../modules/event/eventshell')
                .then((mod) => mod.AppEventShell),
            { noInheritanceAfterFirstLoad: true }, null, null, "nobackground eventshell"
        );

        this.CommunityShell = loadablePageFor(
            () => import(/* webpackChunkName: "shellcommunity" */ '../modules/community/communityshell')
                .then((mod) => mod.AppCommunityShell),
            { noInheritanceAfterFirstLoad: true }, null, null, "nobackground communityshell"
        );

        this.CustomerShell = loadablePageFor(
            () => import(/* webpackChunkName: "shellcustomer" */ '../modules/customer/customershell')
                .then((mod) => mod.AppCustomerShell),
            { noInheritanceAfterFirstLoad: true }, null, null, "nobackground customershell"
        );

        this.DevsPortalShell = loadablePageFor(
            () => import(/* webpackChunkName: "shelldevsportal" */ '../modules/devsportal/devsportal.shell')
                .then((mod) => mod.AppDevsPortalShell),
            { noInheritanceAfterFirstLoad: true }, null, null, "nobackground devsportalshell"
        );
    }

    renderEvent = (navprops) => {
        return <i18NHelperContext.Consumer>
            {(i18nHelper) => <this.EventShell
                {...this.props}
                i18nHelper={i18nHelper}
                navlocation={this.props.location}
                navmatch={this.props.match}
                location={navprops.location}
                match={navprops.match}
            />}
        </i18NHelperContext.Consumer>;
    };

    renderCommunity = (navprops) => {
        return <i18NHelperContext.Consumer>
            {(i18nHelper) => <this.CommunityShell
                {...this.props}
                i18nHelper={i18nHelper}
                navlocation={this.props.location}
                navmatch={this.props.match}
                location={navprops.location}
                match={navprops.match}
            />}
        </i18NHelperContext.Consumer>;
    };

    renderDevsPortal = (navprops) => {
        return <i18NHelperContext.Consumer>
            {(i18nHelper) => <this.DevsPortalShell
                {...this.props}
                i18nHelper={i18nHelper}
                navlocation={this.props.location}
                navmatch={this.props.match}
                location={navprops.location}
                match={navprops.match}
            />}
        </i18NHelperContext.Consumer>;
    };

    render() {
        return <i18NHelperContext.Consumer>
            {(i18nHelper) => <AnimatedSwitch
                className='animatedpagetransitioncontainer'
                location={this.props.location}
                match={this.props.match}
                transitionComponent={PageTransition}
            >
                <Route
                    path={this.props.match.path + "developpers/"}
                    render={this.renderDevsPortal}
                />
                <Route
                    path={this.props.match.path + "events/"}
                    render={(props) => <this.MyEventsShell
                        {...this.props}
                        i18nHelper={i18nHelper}
                        navlocation={this.props.location}
                        navmatch={this.props.match}
                        location={props.location}
                        match={props.match}
                    />}
                />
                <Route
                    path={this.props.match.path + "root/"}
                    render={(props) => <this.RootShell
                        {...this.props}
                        i18nHelper={i18nHelper}
                        navlocation={this.props.location}
                        navmatch={this.props.match}
                        location={props.location}
                        match={props.match}
                    />}
                />
                <Route
                    path={this.props.match.path + "opencontent"}
                    render={(props) => <OpenContentPage
                        {...this.props}
                        i18nHelper={i18nHelper}
                        navlocation={this.props.location}
                        navmatch={this.props.match}
                        location={props.location}
                        match={props.match}
                    />}
                />
                <Route
                    path={this.props.match.path + "licenceexpired"}
                    exact
                    render={(props) => <LicenseExpiredPage
                        {...this.props}
                        i18nHelper={i18nHelper}
                        navmatch={props.match}
                        location={props.location}
                        match={props.match}
                    />}
                />
                <Route
                    path={this.props.match.path + ":customerid/e/:eventid/"}
                    render={this.renderEvent}
                />
                <Route
                    path={this.props.match.path + ":customerid/c/:communityid/"}
                    render={this.renderCommunity}
                />
                <Route
                    path={this.props.match.path + ":customerid/"}
                    render={(props) => <this.CustomerShell
                        {...this.props}
                        i18nHelper={i18nHelper}
                        navlocation={this.props.location}
                        navmatch={this.props.match}
                        location={props.location}
                        match={props.match}
                    />}
                />
                <Route
                    path=""
                    exact
                    render={(props) => <this.MyEventsShell
                        {...this.props}
                        i18nHelper={i18nHelper}
                        navlocation={this.props.location}
                        navmatch={this.props.match}
                        location={props.location}
                        match={props.match}
                    />}
                />
                <Route
                    path=""
                    render={(props) => <NotFoundPage
                        {...this.props}
                        i18nHelper={i18nHelper}
                        location={props.location}
                        match={props.match}
                    />}
                />
            </AnimatedSwitch>}
        </i18NHelperContext.Consumer>;
    }
}

export default AppShellRoutes;